import Validator from 'validatorjs'
import formatErrors from './formatErrors'

let rules = {point: 'required|numeric|min:1'}
const rulesMaker = (values) => ({point: `required|numeric|min:1|max:${values.maxPoint}`})

export default function validatePoint (values, state, props) {
  if (props && props.user) {
    rules = rulesMaker({...values, maxPoint: props.user.point})
  }
  const validator = new Validator(values, rules, {
    required: 'تعداد نعل‌‌ها را مشخص کنید',
    integer: 'این فیلد می بایست عدد باشد',
    max: {
      numeric: 'تعداد نعل‌های شما کافی نمی‌باشد'
    },
    min: {
      numeric: 'مقدار این فیلد نباید کمتر از :min باشد'
    }
  })
  validator.passes()
  return formatErrors(validator.errors.all())
}



// WEBPACK FOOTER //
// ./src/utils/validatePoint.js